export default "__VITE_ASSET__DVSTkEDc__"